import { LeaguePlayerWithTeam } from "@/models/LeaguePlayer";

export function hasPlayerRankingResults(
  players: Pick<LeaguePlayerWithTeam, "gameWins" | "gameLosses">[]
) {
  return players.some((p) => p.gameWins > 0 || p.gameLosses > 0);
}

export function sortPlayersByQttrValueDesc<T extends LeaguePlayerWithTeam>(
  players: T[]
) {
  return [...players].sort((a, b) => {
    const aQttrValue = a.seasonPlayer.qttrValue;
    const bQttrValue = b.seasonPlayer.qttrValue;

    if (aQttrValue == null && bQttrValue == null) {
      return a.rank - b.rank;
    }
    if (aQttrValue == null) return 1;
    if (bQttrValue == null) return -1;
    if (aQttrValue !== bQttrValue) return bQttrValue - aQttrValue;

    return a.rank - b.rank;
  });
}

/** Performance order (+/-, wins, …) when results exist; QTTR only for empty seasons. */
export function sortPlayersForRankingDisplay<T extends LeaguePlayerWithTeam>(
  players: T[]
) {
  if (!hasPlayerRankingResults(players)) {
    return sortPlayersByQttrValueDesc(players);
  }

  return [...players].sort((a, b) => a.rank - b.rank);
}
